<template>
  <div class="home">
    <div id="drag">
      <div class="Yuan" @click="testShowBtn">
        <span></span>
        <span></span>
      </div>
      <div class="Yuan-title">
        <div
          style="height: 20px; width: 100%; cursor: all-scroll"
          class="YuanTitleDrag"
        ></div>
        <div class="zTreeDiv">
          <ul id="WorkPlaneTree" class="ztree"></ul>
        </div>
      </div>
    </div>

    <div id="MyViewerDiv"></div>

    <!-- <button onclick="snaphot();" style="position:absolute;"></button> -->
    <!-- @*视点选择框*@ -->
    <div id="lll">
      <div
        id="div_viewpoint"
        class="m-right-sidebar"
        style="
          position: absolute;
          display: none;
          top: 20px;
          right: 30px;
          transition: none;
        "
      >
        <h2
          class="sdbcName"
          style="font-size: 20px; font-weight: 300; cursor: all-scroll"
        >
          视点保存
        </h2>
        <div
          class="btnClose close_bt_p"
          onclick="bimViewPointNew.hiddenViewPoint();"
          style="color: #000000; font-weight: 300; margin: 8px 3px 0 0"
        >
          ×
        </div>
        <!-- <hr class="v-spacer-large"> -->
        <div class="navBox">
          <!-- <ul id="nav" class="nav" name="nav" style="display: block;">
            <li>
              <b style="border-radius: 15px 0 0 15px;">基本</b>
            </li>
            <li>
              <b>碰撞</b>
            </li>
            <li>
              <b>协作</b>
            </li>
          </ul>-->
          <div id="search_viewpoint" class="search">
            <b class="imgsearch"></b>
            <button
              id="vp-imgsearch"
              style="position: absolute; left: 0"
              class="btnSearch"
              onclick="bimViewPointNew.filterNodes()"
            >
              <img
                width="20px"
                style="position: relative; left: 4px"
                src="../../../assets/img/搜索 (2).png"
              />
            </button>
            <input
              type="text"
              id="vp-searchtxt"
              value="请输入搜索内容..."
              onfocus="if(value=='请输入搜索内容...')  {value=''}"
              onblur="if (value=='') {value='请输入搜索内容...'}"
              onkeypress="bimViewPointNew.viewpoint_keydown(event)"
              name="name"
              style="padding-left: 20px"
            />
            <b
              class="clo1"
              id="vp-close"
              style="
                font-weight: 300;
                position: absolute;
                right: 0;
                color: #c3c3c3;
                font-size: 16px;
              "
              onclick="bimViewPointNew.closeShow()"
              >×</b
            >
          </div>
        </div>
        <div class="body_viewpoint">
          <ul id="treeDemo_viewpoint" class="treeDemo_viewpoint ztree"></ul>
        </div>
        <!-- <hr class="v-spacer-large"> -->
        <button
          class="btn btn-info viewpoint_btn btn_fas"
          style="display: none"
          id="vp-btn-deletebatch"
          data-placement="bottom"
          data-toggle="tooltip"
          title="删除"
          onclick="bimViewPointNew.deleteViewPoints()"
        >
          删除
        </button>
        <el-button
          type="primary"
          id="vp-btn-mark"
          data-placement="bottom"
          data-toggle="tooltip"
          title="涂鸦"
          size="small"
          style="margin: 0 0 0 66px; display: inline-block"
          onclick="bimViewPointNew.showMarkTool()"
          >涂鸦</el-button
        >
        <el-button
          type="primary"
          id="vp-btn-save"
          data-placement="bottom"
          data-toggle="tooltip"
          size="small"
          title="保存"
          onclick="bimViewPointNew.onSaveLayer()"
          style="display: inline-block"
          >保存</el-button
        >
        <button
          size="small"
          type="primary"
          class="btn btn-info"
          id="vp-btn-share"
          title="分享"
          style="display: none"
          data-placement="bottom"
          data-toggle="tooltip"
          onclick="shareStructureQR.viewpointQr()"
        >
          分享
        </button>
        <button
          class="btn btn-info viewpoint_btn btn_fastn"
          style="display: none"
          id="vp-btn-startclash"
          data-placement="bottom"
          data-toggle="tooltip"
          title="发起碰撞"
          onclick="workflowCollision.main('','','-1')"
        >
          发起碰撞
        </button>
        <div
          id="rMenu_viewpoint"
          class="rMenu"
          style="top: 123px; visibility: hidden"
        >
          <ul id="rShowMenu_viewpoint">
            <li
              id="vp_m_add"
              onclick="bimViewPointNew.addTreeNode()"
              style="display: list-item"
            >
              新建视点目录
            </li>
            <li
              id="vp_m_del"
              onclick="bimViewPointNew.removeTreeNode()"
              style="display: list-item"
            >
              删除
            </li>
            <li
              id="vp_m_ren"
              onclick="bimViewPointNew.renameTreeNode()"
              style="display: list-item"
            >
              重命名
            </li>
            <!-- <li
              id="vp_m_faq"
              onclick="bimViewPointNew.createFlow()"
              style="display: list-item;"
            >发起流程</li>-->
            <!-- @*
            <li
              id="vp_m_updateMark"
              onclick="bimViewPointNew.updateMark()"
              style="display: none;"
            >更新涂鸦</li>*@-->
          </ul>
        </div>
      </div>
    </div>
    <div id="box_gray" class="gray"></div>
    <!-- @*过滤器*@ -->
    <div class="filter_box" id="gg" style="cursor: default; display: none">
      <div class="box_title">过滤器</div>
      <div class="btnClose" onclick="bimOriginFilter.hideDoc()">×</div>

      <div class="box_content">
        <div class="tab_title">
          <ul id="tabs" class="clearfix">
            <li class="current" onclick="boxselect(this)">
              <a href="#" title="过滤器">过滤器</a>
            </li>
            <li onclick="boxselect(this)">
              <a href="#" title="框选集">框选集</a>
            </li>
          </ul>
        </div>
        <!-- <ul id="treeDemo" class="ztree content_particulars"></ul> -->
        <div class id="menu_content_box">
          <div id="tab1" class="menu_table" style="display: block">
            <div class="farther" id="list">
              <div class="body_origin_filter">
                <ul id="treeDemo_origin_filter" class="ztree scroll_bar"></ul>
              </div>
              <div
                id="rMenu_origin_filter"
                class="rMenu"
                style="top: 253px; left: 257px; visibility: hidden"
              >
                <ul id="rShowMenu_origin_filter">
                  <li
                    id="origin_f_add"
                    onclick="bimOriginFilter.xx()"
                    style="display: none"
                  >
                    增加
                  </li>
                  <li
                    id="origin_f_del"
                    onclick="bimOriginFilter.yy()"
                    style="display: none"
                  >
                    删除
                  </li>
                  <li
                    id="origin_f_ren"
                    onclick="bimOriginFilter.zz()"
                    style="display: none"
                  >
                    重命名
                  </li>
                </ul>
              </div>
            </div>
            <div class="footr_box">
              <div class="box_options" style="display: none">
                <div class="clearfix">
                  <input
                    class="fl"
                    type="button"
                    onclick="bimOriginFilter.contreChoose()"
                    value="反选"
                  />
                  <input
                    class="fl daochu"
                    type="button"
                    onclick="filterExecute.modelshowEXCELvalue()"
                    id="daochu_btn"
                    value="导出工程量"
                    style="display: none"
                  />
                  <input
                    class="fr top_img"
                    type="button"
                    id="advanced_btn"
                    value="高级选项"
                  />
                </div>
                <div class="sidebar_advanced" style="display: none">
                  <div class="screen_box">
                    <p>
                      <span>参数:</span>
                      <select id="canshu" class="select"></select>
                    </p>
                    <p>
                      <span>条件:</span>
                      <select id="tiaojian" class="select">
                        <option value>请选择筛选条件</option>
                      </select>
                    </p>
                    <p>
                      <span>值:</span>
                      <input value id="chooseValue" />
                    </p>
                  </div>
                </div>
              </div>

              <div class="box_btn_op">
                <div class="clearfix">
                  <!-- @*
                    <input
                      class="fl"
                      type="button"
                      value="确定"
                      onclick="filterExecute.attribute_select()"
                  />*@-->
                  <input
                    class="fr ml_20"
                    type="button"
                    onclick="bimOriginFilter.attribute_save()"
                    value="收藏"
                  />
                </div>
              </div>
            </div>
          </div>
          <div id="tab2" class="menu_table" style="display: none">
            <div class="farther" id="list">
              <div class="body_originOther_filter">
                <ul
                  id="treeDemo_originOther_filter"
                  class="ztree scroll_bar"
                ></ul>
              </div>
              <div
                id="rMenu_originOther_filter"
                class="rMenu"
                style="visibility: hidden"
              >
                <ul id="rShowMenu_originOther_filter">
                  <li
                    id="originOther_f_addPlanDir"
                    onclick="bimOriginFilter.addPlanDir()"
                  >
                    新建目录
                  </li>
                  <li
                    id="originOther_f_delPlan"
                    onclick="bimOriginFilter.removePlan()"
                  >
                    删除
                  </li>
                  <li
                    id="originOther_f_renPlan"
                    onclick="bimOriginFilter.renamePlan()"
                  >
                    重命名
                  </li>
                  <!-- <li id="originOther_f_faq" onclick="bimOriginFilter.createFlow()">发起流程</li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--添加标签 -->
    <div class="AddLable">
      <input type="hidden" id="mobl10" />
      <input type="hidden" id="mobl11" />
      <input type="hidden" id="mobl12" />
      <div>
        <label class="labelName">名称：</label>
        <input id="lableName" type="text" />
      </div>
      <br />
      <div>
        <label class="labelName">地点：</label>
        <input id="lableAddr" type="text" />
      </div>
      <br />
      <div>
        <label class="labelName">拍摄时间：</label>
        <input id="lableTime" type="text" placeholder="yyyy-MM-dd" />
      </div>
      <br />
      <div>
        <label>类型：</label>
        <dl class="labelType">
          <!-- <dd>
            <input type="radio" name="lableType" checked value="1" />
            <label for="material">
              <img src="../../assets/img/bmmc.png" /> 材料
            </label>
          </dd>
          <dd>
            <input type="radio" name="lableType" value="2" />
            <label for="material">
              <img src="../../assets/img/bmmc.png" /> 材料
            </label>
          </dd>-->
        </dl>
      </div>
      <br />
      <div class="isQJ" style="display: none">
        <label class="labelName">是否全景图：</label>
        <input type="radio" name="isQJ" value="1" />是
        <input type="radio" name="isQJ" value="0" checked />否
      </div>
      <br />
      <div class="lableFile">
        <label>文件：</label>
        <button
          type="button"
          class="layui-btn layui-btn layui-btn-sm marginLeft10"
          id="lableFile"
        >
          选择文件
        </button>
      </div>
      <br />
      <div class="qjLink" style="display: none">
        <label class="labelName">全景链接：</label>
        <input id="qjLink" type="text" />
      </div>
      <br />
      <div class="form-group rt">
        <button id="lableSubmit"></button>
        <button
          type="button"
          class="layui-btn"
          onclick="EaBIM.lableSaveChange()"
        >
          提交
        </button>
        <!-- <button type="button" class="layui-btn" id="lableSubmit">提交</button> -->
      </div>
      <br />
    </div>
    <!-- 添加参数 -->
    <div class="AddProperty">
      <p>
        <button
          type="button"
          class="layui-btn layui-btn-normal layui-btn-sm marginLeft10"
          onclick="EaBIM.addPropertyGroup()"
        >
          添加分组
        </button>
        <br />
        <br />
      </p>
    </div>
    <el-card
      class="liveBarCodeShow"
      :body-style="{ padding: '10px' }"
      shadow="hover"
      v-show="modelId"
    >
      <div style="display: flex; justify-content: center; align-item: center">
        <div :class="addClass" v-show="isShowaddClass">
          <el-select
            filterable
            v-model="value"
            placeholder="请选择"
            @change="typeChange"
          >
            <el-option
              v-for="item in options2"
              :key="item.tpst01"
              :label="item.tpst03"
              :value="item.tpst01"
            ></el-option>
          </el-select>
        </div>
        <div :class="addClass" v-show="isShowaddClass">
          <el-input
            placeholder="请输入名称"
            class="search-input"
            v-model="query"
          ></el-input>
        </div>
        <div :class="addClass" v-show="isShowaddClass">
          <el-button icon="el-icon-search" @click="aa()"></el-button>
        </div>
        <div>
          <el-button
            style="float: right"
            :icon="iconClass"
            @click="isShow2"
          ></el-button>
        </div>
      </div>
      <div :class="addClass" v-show="isShowaddClass">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="bacd05" label="类型名称">
            <template slot-scope="scope">
              <el-button
                style="color: skyblue; cursor: pointer"
                :title="scope.row.bacd05"
                @click="viewThisLable(scope.row)"
                >{{
                  scope.row.bacd05.length > 5
                    ? scope.row.bacd05.substr(0, 5) + "..."
                    : scope.row.bacd05
                }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="bacd04" label="构件ID">
            <template slot-scope="scope">
              <span>{{ scope.row.bacd04 }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            small
            align="center"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[100, 50, 10]"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </el-card>
    <!-- <el-card
      class="liveBarCodeShow"
      :body-style="{ padding: '10px' }"
      shadow="hover"
      v-show="modelId"
    >
    </el-card> -->
    <div :class="addClass2" v-show="isShowLocationModel">
      <el-row>
        <el-col :span="12" :offset="6">
          <p style="font-size: 24px">{{ ModelName }}</p>
        </el-col>
        <el-col :span="3" :offset="3">
          <el-button size="small" type="danger" @click="isShowLocationModel3()"
            >X</el-button
          >
        </el-col>
      </el-row>
      <hr />
      <br />
      <el-row style="height: 200px; overflow: auto">
        <el-col :span="16">
          <p
            style="font-size: 17px; height: 40px; line-height: 40px"
            v-for="(item, index) in bacdObject"
            :key="index"
            :title="item"
          >
            {{ item.substr(0, 18) }}{{ item.length > 18 ? "..." : "" }}
          </p>
        </el-col>
        <el-col :span="8">
          <div id="Code"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  GetModelListByXid,
  GetModelLableList,
  GetTempsetList,
  GetModelBarCodeList,
  GetModelBarCodeDbids,
  GetWorkPlaneTree2,
  FindWorkPlaneModel,
} from "@/setAxios";
import interact from "interactjs";
export default {
  name: "viewModel",
  components: {},
  data() {
    return {
      isShowaddClass: true,
      isOnclick: true,
      isShowLocationModel: false,
      isClose: false,
      query: "",
      iconClass: "el-icon-arrow-left",
      addClass: "animated fadeInLeft back",
      addClass2: "animated fadeInLeft locationModel",
      isShow: true,
      tableData: [],
      url: "",
      options: {},
      value: 0,
      options2: [],
      isdblclick: true,
      btnColor: "",
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      bacdObject: [],
      ModelName: "",
      mid: 0,
      timer: null,
      modelId: "",
      objs: null,
    };
  },
  methods: {
    // 判断类型
    judge(item) {
      if (item.wopl07 == 1) {
        return (item.iconSkin = "pIcon01");
      } else if (item.wopl07 == 2) {
        return (item.iconSkin = "pIcon02");
      } else if (item.wopl07 == 3) {
        return (item.iconSkin = "pIcon03");
      } else {
        return (item.iconSkin = "pIcon04");
      }
    },
    //初始化ztree
    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: false,
        },
        data: {
          key: {
            name: "label",
          },
          simpleData: {
            enable: true,
            idKey: "ID",
            pIdKey: "ParentId",
          },
        },
        callback: {
          onClick: onclick,
        },
      };
      this.objs = $.fn.zTree.init($("#WorkPlaneTree"), setting, this.options);
      if (this.objs != null) {
        if (localStorage.treeNid) {
          var currentNode = this.objs.getNodeByParam(
            "ID",
            localStorage.treeNid
          );
          var name = currentNode.tId + "_a";
          $("#" + name).click();
        } else {
          $("#WorkPlaneTree_1_a").click();
        }
      }
      function onclick(event, treeId, treeNode) {
        localStorage.setItem("treeNid", treeNode.ID);
        _this.showModel(treeNode.ID);
      }
    },
    testShowBtn() {
      if ($(".Yuan-title").css("display") != "none") {
        $(".Yuan-title").css("display", "none");
      } else {
        $(".Yuan-title").css("display", "block");
      }
    },
    typeChange(data) {
      this.mid = data;
      this.loadBarCode();
      this.pageIndex = 1;
      this.pageSize = 10;
    },
    loadBarCode() {
      let params = {
        xid: localStorage.xid,
        mid: this.mid,
        modelId: this.modelId,
      };
      GetModelBarCodeDbids(params).then((res) => {
        if (res.Data) {
          EaBIM.loadBarCode(res.Data);
        }
      });
      this.aa();
    },
    viewThisLable(data) {
      var obj = [{ dbids: data.bacd11, color: data.tpst07 }];
      EaBIM.loadBarCode(obj);
      this.isShowLocationModel2(data);
    },
    isShow2() {
      let _this = this;
      if (this.isShow == false) {
        this.isShow = true;
        this.isShowaddClass = true;
        this.addClass = "animated fadeInLeft back";
        this.iconClass = "el-icon-arrow-left";
      } else {
        this.addClass = "animated fadeOutLeft back";
        this.iconClass = "el-icon-arrow-right";
        this.isShow = false;
        setTimeout(function () {
          _this.isShowaddClass = false;
        }, 300);
      }
    },
    isShowLocationModel2(data3) {
      const getSelect = (targetNode) => {
        if (window.getSelection) {
          //chrome等主流浏览器
          var selection = window.getSelection();
          var range = document.createRange();
          range.selectNode(targetNode);
          selection.removeAllRanges();
          selection.addRange(range);
        } else if (document.body.createTextRange) {
          //ie
          var range = document.body.createTextRange();
          range.moveToElementText(targetNode);
          range.select();
        }
      };

      const clipboardHandler = (nodeName, event) => {
        event = event || nodeName; //不传参时
        const type = Object.prototype.toString
          .call(nodeName)
          .replace(/\[object\s|\]/g, "");
        const target = event.target || event.srcElement;

        var result = false;
        switch (type) {
          case "String":
            result = target.nodeName.toLowerCase() === nodeName;
            break;
          case "Array":
            result = nodeName.some(
              (item) => target.nodeName.toLowerCase() === item
            );
            break;
          case "Object":
            nodeName = null;
          default:
            result = target.nodeName === "IMG";
        }

        if (result) {
          getSelect(target);
          document.execCommand("copy");
          this.$message({
            type: "success",
            message: "复制成功",
          });
        }
      };

      this.isShowLocationModel = true;
      this.bacdObject = [];
      if (data3.tslk) {
        this.bacdObject = data3.tslk.split("^@^");
      }
      this.ModelName = data3.tpst04;
      this.bacdObject.unshift("构件ID:" + data3.bacd04);
      this.bacdObject.unshift("构件名称:" + data3.bacd05);
      $("#Code").empty();
      var qrcode = new QRCode("Code", {
        text: data3.bacd10,
        width: 128,
        height: 128,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      var img = document.querySelectorAll("img")[0];
      img.addEventListener("click", clipboardHandler);
      this.addClass2 = "animated fadeInLeft locationModel";
      this.isClose = false;
    },
    isShowLocationModel3() {
      var _this = this;
      this.addClass2 = "animated fadeOutLeft locationModel";
      setTimeout(function () {
        _this.isShowLocationModel = false;
      }, 300);
    },
    viewers(data) {
      if (data.type == 1) {
        this.modelId = data.modelId;
        data.enterType = "tmgl";
        this.loadBarCode();
      } else {
        this.modelId = "";
      }
      EaBIM.localServerModels(data);
    },
    getData() {
      let params = {
        xid: localStorage.getItem("xid"),
        pid: -1,
      };
      GetWorkPlaneTree2(params).then((res) => {
        this.options = res.Data;
        this.options.forEach((item) => {
          this.judge(item);
        });
        this.init();
      });
      this.bb();
    },
    bb() {
      let params = {
        xid: localStorage.getItem("xid"),
        pageIndex: 1,
        pageSize: 1000000,
      };
      GetTempsetList({ params }).then((res) => {
        res.Data.list.unshift({
          tpst01: 0,
          tpst03: "全部",
        });
        this.options2 = res.Data.list;
      });
    },
    showModel(value, index) {
      if (value.length) {
        value = value[0];
      }
      let params = {
        id: value,
      };
      FindWorkPlaneModel(params).then((res) => {
        if (res.Data == null) {
          this.$message({
            type: "warning",
            message: this.$t('工单任务.此节点未绑定模型或选择集'),
          });
          return false;
        }
        let data = res.Data;
        this.viewers(data);
      });
    },
    aa() {
      let params = {
        xid: localStorage.xid,
        mid: this.mid,
        searchword: this.query,
        modelId: this.modelId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      GetModelBarCodeList({ ...params }).then((res) => {
        this.tableData = res.Data.list;
        this.total = res.Data.total;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.aa();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.aa();
    },
    reLoadBar() {
      if (this.objs != null) {
        if (localStorage.treeNid) {
          var currentNode = this.objs.getNodeByParam(
            "ID",
            localStorage.treeNid
          );
          var name = currentNode.tId + "_a";
          $("#" + name).click();
        } else {
          $("#WorkPlaneTree_1_a").click();
        }
      }
    },
  },
  created() {
    if (
      (this.$store.state.permissions != null &&
        this.$store.state.permissions.includes("1061")) ||
      this.$store.state.isProject
    ) {
      EaBIM.addLocation = true;
    }
    this.flushSession();
    this.getData();
    window.locatinModel = this;
  },
  mounted() {
    document.oncontextmenu = function () {
      return false;
    };
    Fcis.Fc(".Yuan", "#drag");
    Fcis.Fc(".lll", "#div_viewpoint");
    Fcis.Fc(".lll", "#gg");

    interact(".Yuan-title").resizable({
      edges: { top: false, left: false, bottom: true, right: true },
      listeners: {
        move: function (event) {
          let { x, y } = event.target.dataset;

          x = (parseFloat(x) || 0) + event.deltaRect.left;
          y = (parseFloat(y) || 0) + event.deltaRect.top;

          Object.assign(event.target.style, {
            width: `${event.rect.width}px`,
            height: `${event.rect.height}px`,
            transform: `translate(${x}px, ${y}px)`,
          });

          Object.assign(event.target.dataset, { x, y });
        },
      },
    });
  },
};
</script>

<style lang="less" scoped>
@import url("../../../../public/Content/css/style.css");

#drag {
  left: 90%;
  top: 15%;
}
.testS {
  left: 1490px;
  top: 160px;
}
.testS-title {
  top: 180px;
  left: 1500px;
}
// .adsk-viewing-viewer .adsk-toolbar{
//   left: 50%;
// }
/deep/ .view {
  padding: 0;
}
#MyViewerDiv {
  height: 100%;
  width: 100%;
  position: absolute;
  // float: left;
}
.home {
  // overflow: auto;
  height: 100%;
  // position: relative;
}

.body_viewpoint .treeDemo_viewpoint {
  background: rgba(255, 255, 255, 0.8);
  width: 96%;
  height: 100%;
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 15px;
}
.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}
.liveBarCodeShow {
  z-index: 10;
  position: absolute;
  padding: 0px;
  margin: 0px;
}
.search-input {
  width: 140px;
}
.back {
  max-height: 500px;
  overflow: auto;
}
.locationModel {
  position: absolute;
  top: 150px;
  right: 20%;
  border-radius: 5px;
  height: 350px;
  width: 600px;
  z-index: 10;
  background: #fff;
  padding: 20px 50px;
  box-sizing: border-box;
  //   overflow: auto;
}
.el-pagination {
  white-space: pre-wrap;
}
</style>
